import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DatePicker from './DatePicker.json';
import Header from './Header.json';
import MeasurementTable from './MeasurementTable.json';
import DataRow from './DataRow.json';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import StudyBrowser from './StudyBrowser.json';
import SidePanel from './SidePanel.json';
import Modes from './Modes.json';
import PatientInfo from './PatientInfo.json';
import Notification from './Notification.json';
import ContextMenu from './ContextMenu.json';
import Dialog from './Dialog.json';
import Modals from './Modals.json';
import Local from './Local.json';
import ErrorBoundary from './ErrorBoundary.json';
import Hps from './Hps.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';
import CaptureViewportModal from './CaptureViewportModal.json';
import Tools from './Tools.json';
import SegmentationPanel from './SegmentationPanel.json';
import Onboarding from './Onboarding.json';
import Colormaps from './Colormaps.json';
import PanelSUV from './PanelSUV.json';
import ROIThresholdConfiguration from './ROIThresholdConfiguration.json';
import USAnnotationPanel from './USAnnotationPanel.json';

export default {
  fr: {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DatePicker,
    Header,
    MeasurementTable,
    DataRow,
    StudyList,
    UserPreferencesModal,
    ViewportDownloadForm,
    StudyBrowser,
    SidePanel,
    Modes,
    PatientInfo,
    Notification,
    ContextMenu,
    Dialog,
    Modals,
    Local,
    ErrorBoundary,
    Hps,
    ToolbarLayoutSelector,
    WindowLevelActionMenu,
    CaptureViewportModal,
    Tools,
    SegmentationPanel,
    Onboarding,
    Colormaps,
    PanelSUV,
    ROIThresholdConfiguration,
    USAnnotationPanel,
  },
};
